<header
    class="sticky top-0 z-30
           flex h-[76px]
           items-center
           border-b border-[#ebe7e3]
           bg-[#fffdfb]/92
           px-4
           shadow-[0_1px_0_rgba(28,25,23,0.015)]
           backdrop-blur-xl
           sm:px-6
           lg:px-8"
>

    <!-- ====================================================== -->
    <!-- MOBILE MENU -->
    <!-- ====================================================== -->

    <button
        type="button"
        class="mr-3
               flex h-10 w-10
               items-center
               justify-center
               rounded-xl
               text-[#78716c]
               transition
               hover:bg-[#f4efec]
               hover:text-[#d95235]
               lg:hidden"
        (click)="menuClick.emit()"
    >

        <nz-icon
            nzType="menu"
            nzTheme="outline"
        ></nz-icon>

    </button>


    <!-- ====================================================== -->
    <!-- PAGE TITLE -->
    <!-- ====================================================== -->

    <div
        class="min-w-[200px]"
    >

        <div
            class="text-[9px]
                   font-semibold
                   uppercase
                   tracking-[0.18em]
                   text-[#a8a29e]"
        >
            RestaurantOS
        </div>


        <h1
            class="mt-0.5
                   text-[18px]
                   font-semibold
                   tracking-tight
                   text-[#292524]"
        >
            {{ pageTitle() }}
        </h1>

    </div>


    <!-- ====================================================== -->
    <!-- SEARCH -->
    <!-- ====================================================== -->

    <div
        class="mx-auto
               hidden w-full
               max-w-[520px]
               md:block"
    >

        <button
            type="button"
            class="group
                   flex h-11 w-full
                   items-center
                   gap-3
                   rounded-xl
                   border border-[#e7e2df]
                   bg-[#faf8f7]
                   px-4
                   text-left
                   text-sm
                   text-[#a8a29e]
                   transition-all
                   duration-200
                   hover:border-[#d8cfca]
                   hover:bg-white
                   hover:shadow-[0_5px_18px_rgba(28,25,23,0.04)]"
        >

            <nz-icon
                nzType="search"
                nzTheme="outline"
                class="text-[#a8a29e]
                       transition
                       group-hover:text-[#d95235]"
            ></nz-icon>


            <span
                class="flex-1"
            >
                Buscar pedidos, mesas, clientes...
            </span>


            <span
                class="rounded-md
                       border border-[#e5dfdc]
                       bg-white
                       px-2 py-0.5
                       text-[10px]
                       font-medium
                       text-[#a8a29e]"
            >
                ⌘ K
            </span>

        </button>

    </div>


    <!-- ====================================================== -->
    <!-- RIGHT -->
    <!-- ====================================================== -->

    <div
        class="ml-auto
               flex items-center
               gap-2
               md:ml-6"
    >

        <!-- DATE -->

        <button
            type="button"
            class="hidden h-10
                   items-center gap-2
                   rounded-xl
                   border border-[#e7e2df]
                   bg-white
                   px-3
                   text-xs
                   font-medium
                   text-[#57534e]
                   transition
                   hover:border-[#d9d0cb]
                   hover:bg-[#faf8f7]
                   xl:flex"
        >

            <nz-icon
                nzType="calendar"
                nzTheme="outline"
                class="text-[#78716c]"
            ></nz-icon>

            Hoy

        </button>


        <!-- NOTIFICATIONS -->

        <button
            type="button"
            class="relative
                   flex h-10 w-10
                   items-center
                   justify-center
                   rounded-xl
                   text-[#78716c]
                   transition
                   hover:bg-[#f4efec]
                   hover:text-[#d95235]"
        >

            <nz-badge
                nzDot
            >

                <nz-icon
                    nzType="bell"
                    nzTheme="outline"
                    class="text-[17px]"
                ></nz-icon>

            </nz-badge>

        </button>


        <!-- DIVIDER -->

        <div
            class="mx-1
                   hidden h-8 w-px
                   bg-[#ebe7e3]
                   sm:block"
        ></div>


        <!-- ================================================== -->
        <!-- PROFILE -->
        <!-- ================================================== -->

        <button
            type="button"
            class="group
                   flex items-center
                   gap-3
                   rounded-xl
                   px-1.5 py-1
                   transition
                   hover:bg-[#f7f2ef]"
            (click)="logout()"
        >

            <nz-avatar
                [nzText]="initials()"
                nzSize="large"
                class="!bg-[#2a201c]
                       !text-[#fff8f4]
                       !shadow-[0_4px_14px_rgba(28,25,23,0.10)]"
            ></nz-avatar>


            <div
                class="hidden
                       text-left
                       lg:block"
            >

                <div
                    class="text-xs
                           font-semibold
                           text-[#292524]"
                >
                    {{ displayName() }}
                </div>


                <div
                    class="mt-0.5
                           max-w-[150px]
                           truncate
                           text-[10px]
                           text-[#a8a29e]"
                >
                    {{ primaryRole() }}
                </div>

            </div>


            <nz-icon
                nzType="down"
                nzTheme="outline"
                class="hidden
                       text-[10px]
                       text-[#a8a29e]
                       transition
                       group-hover:text-[#d95235]
                       lg:block"
            ></nz-icon>

        </button>

    </div>

</header>